export default "__VITE_ASSET__B645NpaU__"